import { jsx as _jsx } from "react/jsx-runtime";
import PatientJourneys from 'pages/PatientJourneys';
import ShowPatientJourney from 'pages/PatientJourneys/ShowPatientJourney';
import StationQueue from 'pages/PatientJourneys/StationQueue';
import { Route } from 'react-router';
import AuthorizationService from 'routes/AuthorizationService';
import { Index, Queue, Show } from 'constants/actions';
import { PatientJourney as PatientJourneyResource } from 'constants/resources';
var PatientJourneyRoutes = function () {
    return ([
        _jsx(Route, { caseSensitive: true, path: '/patient_journeys', element: AuthorizationService.getAuthorizedElement(_jsx(PatientJourneys, {}), Index, PatientJourneyResource) }, 'patient-journeys-route'),
        _jsx(Route, { caseSensitive: true, path: '/patient_journeys/queue', element: AuthorizationService.getAuthorizedElement(_jsx(StationQueue, {}), Queue, PatientJourneyResource) }, 'patient-journey-queue-route'),
        _jsx(Route, { caseSensitive: true, path: '/patient_journeys/:id', element: AuthorizationService.getAuthorizedElement(_jsx(ShowPatientJourney, {}), Show, PatientJourneyResource) }, 'show-patient-journey-route')
    ]);
};
export default PatientJourneyRoutes;
